import { atom } from "recoil";

export const complianceFormTemplateCode = atom({
    key: "complianceFormTemplateCode",
    default: "",
});